import React, { PureComponent } from 'react';
import './ToolTip.scss';

class Tooltip extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      defStyles: {
        ...props.style,
        position: 'absolute',
        top: '0',
        padding: '2px 4px',
        borderRadius: '2px',
        fontSize: '10px',
        fontWeight: 600,
        willChange: 'transform',
        textTransform: 'uppercase',
        zIndex: '10000',
        width: 'auto',
      },
      parentCoords: {},
      tooltipWidth: null,
      tooltipHeight: null,
    };
    this.parent = null;
  }

  componentDidMount() {
    this.parent = document.querySelector(`${this.props.node}`);
    if (this.parent) {
      this.setState({
        ...this.state,
        parentCoords: this.parent.getBoundingClientRect(),
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.show && this.props.show) {
      const { width, height } = document
        .querySelector('.tooltip')
        .getBoundingClientRect();
      this.setState({
        ...this.state,
        tooltipWidth: width,
        tooltipHeight: height,
      });
    }
  }

  setStyle = position => {
    const {
      defStyles,
      parentCoords: { x, bottom, top, height, width },
      tooltipWidth,
      tooltipHeight,
    } = this.state;
    const wOffset = Math.abs(height - tooltipWidth);
    const hOffset = Math.abs(height - tooltipHeight);

    switch (position) {
      case 'top':
        return {
          ...defStyles,
          transform: `translate3d(${x - wOffset / 2}px, ${top -
            tooltipHeight -
            10}px, 0)`,
        };
      case 'bottom':
        return {
          ...defStyles,
          transform: `translate3d(${x - wOffset / 2}px, ${bottom + 10}px, 0)`,
        };
      case 'bottom-center':
        return {
          ...defStyles,
          transform: `translateX(50%)`,
          right: '50%',
        };
      case 'bottom-right':
        return {
          ...defStyles,
          right: '0',
        };
      case 'left':
        return {
          ...defStyles,
          transform: `translate3d(${x - tooltipWidth - 10}px, ${top +
            hOffset / 2}px, 0)`,
        };
      case 'right':
        return {
          ...defStyles,
          transform: `translate3d(${x + width + 10}px, ${top +
            hOffset / 2}px, 0)`,
        };
      default:
        break;
    }
  };

  render() {
    const { text, show, position, style, tooltipClass } = this.props;
    const styles = show ? this.setStyle(position) : {};
    return show ? (
      <span
        className={`tooltip ${tooltipClass && tooltipClass}`}
        style={styles}
        role="tooltip"
        data-testid="tooltip"
      >
        <span
          className={`arrow ${position}`}
          style={{
            backgroundColor: style.backgroundColor,
          }}
        />
        {text}
      </span>
    ) : null;
  }
}

export default Tooltip;
